export const DEALS = ['great', 'good', 'fair'];

export const HEADLINE_TOOLTIP = {
  text: 'Manufacturers place restrictions on the prices dealers can advertise online. If a dealer advertises a price online, then they must offer it to everybody. This is why dealers will only reveal their lowest pricing when you contact them directly.',
  placement: 'bottom',
};

export const GOOD_DEAL_INDEX = 1;

const VDP_PAGE_CATEGORY = 'model_car_inventory';
const VDP_BUY_ONLINE_PAGE_CATEGORY = 'used_model_car_inventory';

export const EMBEDDED_PAGE_CATEGORIES = [VDP_PAGE_CATEGORY, VDP_BUY_ONLINE_PAGE_CATEGORY];
